module.exports = __webpack_public_path__ + "d7882f4f2ff9589c2d54639172f5c425.woff2";